var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('ul',{staticClass:"links"},[_vm._l((_vm.links),function(link,href){return _c('li',{class:!link ? "break" : ""},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(link))])])}),_vm._v(" "),_c('li',{staticClass:"break"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":_vm.logout}},[_vm._v("Log Out")])])],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08809852","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
// module id = 487
// module chunks = 1